export enum CsvDataLoaderAction {
  NONE = 'NONE',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}


